import GrComponentFactory from "../../../gr_component_factory";
import AskTheAuthorInfoContainer from "./ask_the_author_info_container";
import AskTheAuthorFeaturedAuthorsStore from "../../../../react_stores/ask_the_author_featured_authors_store";
import AskTheAuthorFeaturedAuthorsActions from "../../../../react_actions/ask_the_author/featured_authors_actions";
import Reflux from "reflux";

export default GrComponentFactory.createClass({
  mixins: [Reflux.connect(AskTheAuthorFeaturedAuthorsStore, "askTheAuthorFeaturedAuthorsStore")],

  displayName: "FeaturedAuthorsList",

  loadMore(){
    AskTheAuthorFeaturedAuthorsActions.loadMoreFeaturedAuthors();
  },

  render() {
    const state = this.state.askTheAuthorFeaturedAuthorsStore;
    const authors_data = state.authors;
    const remainingAuthors = state.total-state.authors.length;
    let loadMoreButton;
    if (remainingAuthors > 0)
      loadMoreButton = <button className="gr-buttonAsLink askTheAuthorLoadMoreFeaturedAuthorsButton"
                               onClick={this.loadMore}> More featured authors...
                       </button>;
    return (
      <div>
        {
          authors_data.map((author_data) => (
              <div key={`${author_data.id}-container`}>
                <AskTheAuthorInfoContainer
                  key = {author_data.profileUrl}
                  authorUser = {{ id: author_data.id,
                                  name: author_data.name,
                                  profileImage: author_data.profileImage,
                                  profileUrl: author_data.profileUrl }}
                  answersCount = {author_data.answersCount}
                  answerURL = {author_data.answerURL}
                  questionURL = {author_data.questionURL}
                  authorTagline = {author_data.authorTagline}
                  ATAenabled = {author_data.ATAenabled}
                />
                <div className="u-topGrayBorder" key={`${author_data.id}-border`}>
                  <div className="u-marginTopTiny" key={`${author_data.id}-border-margin`} />
                </div>
              </div>
          ))
        }
        {
          loadMoreButton
        }
      </div>
    );
  },
});
